/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Divider, Switch, TextField, Typography } from "@mui/material";
import { useRef } from "react";
import DatePicker from "react-datepicker2";
import { Dropdown, MultipleImages, TextInput } from "../../../../../shared/ui/common/index.js";
import { AD_Type, PRICE_TYPE } from "../../../../../shared/lib/constants.js";

const StepOne = ({
  nextStep,
  setCreatedId,
  setCreatedName,
  setCatSearchWord,
  setBoothSearchWord,
  catSearchWord,
  boothSearchWord,
  showingBooth,
  showingCats,
  error,
  setData,
  data,
}) => {
  const startTimeCalender = useRef();
  const endTimeCalender = useRef();
  console.log(error,'errorerror')
  return (
    <>
      <Typography variant="body2" className="text-[#262626]">
        اطلاعات تبلغ را تکمیل نمائید.
      </Typography>
      <Divider sx={{ borderStyle: "dashed !important" }} />
      <div className="grid lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-2 gap-x-8 gap-y-4">
        <div className="col-span-3">
          <TextInput
            label="عنوان تبلغ"
            change={(e) => setData({ ...data, title: e })}
            currentValue={data?.title}
            err={error === "title"}
          />
        </div>

        <Box className="flex items-center">
          <span style={{ fontFamily: "IRANSansFa" }}> پرداخت شده:</span>
          <Switch
            checked={Boolean(data?.active)}
            onChange={() => setData({ ...data, active: !data?.active })}
          />
        </Box>
      </div>

      <div className="grid lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-2 gap-x-8 gap-y-4">
        <Dropdown
          search={(e) => {
            setBoothSearchWord(e.target.value);
          }}
          searchValue={boothSearchWord}
          title="انتخاب غرفه"
          data={showingBooth}
          value={showingBooth?.find((item) => item.id === data?.boothId)}
          change={(e) => setData({ ...data, boothId: e?.id })}
          err={error === "category"}
        />
        <Dropdown
          search={(e) => {
            setCatSearchWord(e.target.value);
          }}
          searchValue={catSearchWord}
          title="انتخاب دسته بندی"
          data={showingCats}
          value={showingCats?.find((item) => item.id === data?.categoryId)}
          change={(e) => setData({ ...data, categoryId: e?.id })}
          err={error === "category"}
        />
        <TextField
          label="شماره مخاطب"
          onChange={(e) => setData({ ...data, contactNumber: e.target.value })}
          value={data?.contactNumber}
          type="number"
          onInput={(e) => {
            e.target.value = e.target.value
              .replace(/[^0-9]/g, "")
              .replace(/(\..*?)\..*/g, "$1");
          }}
          error={error === "contactNumber"}
        />

        <TextInput
          label="تگ "
          change={(e) => setData({ ...data, tag: e })}
          currentValue={data?.tag}
          err={error === "tag"}
        />
        <Dropdown
          title=" نوع"
          data={AD_Type}
          value={AD_Type?.find((item) => item.id === data?.type)}
          change={(e) => setData({ ...data, type: e?.id })}
          err={error === "type"}
        />

        <TextInput
          label="قیمت"
          change={(e) => setData({ ...data, deposite: e })}
          currentValue={data?.deposite}
          err={error === "deposite"}
        />
        <Dropdown
          title=" نوع قیمت"
          data={PRICE_TYPE}
          value={PRICE_TYPE?.find((item) => item.id === data?.priceType)}
          change={(e) => setData({ ...data, priceType: e?.id })}
          err={error === "priceType"}
        />
        {/*     <TextInput
          label="سپرده"
          change={setDeposite}
          currentValue={deposite}
          err={error === "deposite"}
        /> */}
        <div className="relative  w-full">
          <DatePicker
            value={data?.startTime}
            isGregorian={false}
            ref={startTimeCalender}
            onChange={(value) => {
              if (value) {
                setData({
                  ...data,
                  startTime: value,
                  payDate: toIsoString(new Date(value._d)),
                  valueStartDate: value._d.toLocaleDateString("fa"),
                });
              }
            }}
          />
          <TextField
            onMouseUp={() => startTimeCalender.current?.setOpen(true)}
            InputProps={{
              inputProps: {
                style: { textAlign: "right", width: "100%" },
              },
            }}
            variant="outlined"
            value={data?.valueStartDate ? data?.valueStartDate : ""}
            label={" تاریخ پرداخت "}
            autoComplete="off"
            fullWidth
          />
        </div>
        <div className="relative  w-full">
          <DatePicker
            value={data?.endTime}
            isGregorian={false}
            ref={endTimeCalender}
            onChange={(value) => {
              if (value) {
                setData({
                  ...data,
                  endTime: value,
                  validTo: toIsoString(new Date(value._d)),
                  valueEndDate: value._d.toLocaleDateString("fa"),
                });
              }
            }}
          />
          <TextField
            onMouseUp={() => endTimeCalender.current?.setOpen(true)}
            InputProps={{
              inputProps: {
                style: { textAlign: "right", width: "100%" },
              },
            }}
            variant="outlined"
            value={data?.valueEndDate ? data?.valueEndDate : ""}
            label={" تاریخ اعتبار "}
            autoComplete="off"
            fullWidth
          />
        </div>
      </div>
      <MultipleImages
        files={data?.files}
        setFiles={(e) => setData({ ...data, files: e })}
        selectedProductImage={data?.selectedProductImage}
        setselectedProductImage={(e) =>
          setData({ ...data, selectedProductImage: e })
        }
      />
      <TextField
        multiline
        rows={3}
        label="توضیحات"
        onChange={(e) => setData({ ...data, description: e.target.value })}
        value={data?.description}
        error={error === "description"}
      />
    </>
  );
};

export default StepOne;
function toIsoString(date) {
  var tzo = -date.getTimezoneOffset(),
    dif = tzo >= 0 ? "+" : "-",
    pad = function (num) {
      return (num < 10 ? "0" : "") + num;
    };
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    "00" +
    ":" +
    "00" +
    ":" +
    "00"
  );
}
